module.exports = __webpack_public_path__ + "images/category_lp/common/reason3-woman-20_86cd5c38cb0caa1ef6c1d3d7a0be30b2.jpg";